<div *ngIf="customerId && hasUserAccess()" class="add-favorite is-size-5" >
  <a (click)="toggleFavorite()">
    <fa-icon *ngIf="!favorite" [icon]="faHeartRegular"  role="img" aria-label="Das Produkt als Favorit kennzeichnen"></fa-icon>
    <fa-icon *ngIf="favorite" [icon]="faHeartSolid" role="img" aria-label="Das Produkt befindet sich in Ihrer Favoritenliste"></fa-icon>
  </a>
</div>
